import { BASE_URL } from 'config/urls';

import { get, requestSdk } from 'utils/sdk';

export const googleClassroomSyncDetails = async (syncId) =>
  await requestSdk(() =>
    get(`${BASE_URL}/v1/integrations/google/classroom/sync/${syncId}`)
  );
